export default __webpack_public_path__ + "static/media/25120418.ed104714.jpg";